import React, { useEffect, useLayoutEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router';

import { Languages, SUPPORTED_LANGUAGES } from '@/shared/constants';
import { replaceLanguageSegment } from '@/shared/services/helpers/language';

const LanguageGuard: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { lang } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const supportedLngs = useMemo(
    () => i18n.options.supportedLngs || SUPPORTED_LANGUAGES,
    [i18n.options.supportedLngs]
  );

  useLayoutEffect(() => {
    if (lang && !supportedLngs.includes(lang)) {
      // Неподдерживаемый язык → тот же путь на ru (корень сегмента — лендинг).
      navigate(
        replaceLanguageSegment(location.pathname, Languages.ru) +
          location.search,
        { replace: true }
      );
    } else if (location.pathname === '/') {
      const target = supportedLngs.includes(i18n.language)
        ? i18n.language
        : Languages.ru;

      navigate(`/${target}`, { replace: true });
    } else if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [location, lang, i18n, supportedLngs, navigate]);

  // Настройки языка документа для SEO
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return children;
};

export { LanguageGuard };
